// ©2024 Austin App House. All rights reserved.
import React from 'react';
import axios from 'axios';
import fileDownload from 'js-file-download';
import Notification from '../notification';
import DashboardIcon from '../dashboard/icons/DashboardIcon';

const TaxInfoButton = () => (
  <button
    type="button"
    className="sidebar-link sidebar-link--export"
    title="Export tax info"
    onClick={(e) => {
      e.preventDefault();
      exportTaxInfoContractors();
    }}
  >
    <span className="sidebar-icon">
      <DashboardIcon name="export" />
    </span>
    <span className="sidebar-label">Export tax info</span>
  </button>
);

export default TaxInfoButton;

const exportTaxInfoContractors = async () => {
  await axios.get('/api/admin/contractors/taxinfo/export', {
    responseType: 'blob',
  }).then((res) => {
    fileDownload(res.data, 'taxinfo.xlsx');
  }).catch((error) => {
    Notification('error', {
      message: error.response?.data?.message || error.message,
    });
  });
};
